import * as React from 'react';

import {getMentionsConfig} from 'shells/rich-textarea/get-mentions-config';
import {RichTextarea, type Props as RichTextareaProps} from 'shells/rich-textarea/rich-textarea';

import type {GetTeams_teams as Team} from 'nutshell-graphql-types';

import {TranscribeButtonContainer} from '../../speech-to-text/transcribe-button-container';
import type {TranscribeButtonContainerProps} from '../../speech-to-text/transcribe-button-container';

import {useGetTeams} from '../graphql/hooks/use-get-teams';

import styles from './textarea-mentionable.module.css';

type Props = Omit<RichTextareaProps, 'config' | 'teams'> & {
    includeNotetaker?: boolean;
    notetakerProps?: TranscribeButtonContainerProps;
    // If we want this component to load instantly, we can preload the teams and
    // pass them here. We will skip the in-component query for teams.
    preloadedTeams?: Team[] | null | undefined;
};

export function TextareaMentionable(props: Props) {
    const {includeNotetaker, notetakerProps, preloadedTeams, ...rest} = props;
    const {teams, isLoading: isLoadingTeams} = useGetTeams(Boolean(preloadedTeams));

    const teamsToUse = preloadedTeams || teams;

    return (
        // The updated value for teams causes the component to autofocus on the page.
        // If the Quill editor is loaded before the teams query finishes, for whatever reason
        isLoadingTeams ? null : (
            <>
                <RichTextarea
                    config={{
                        modules: {
                            toolbar: false,
                        },
                        formats: ['mention'],
                        images: false,
                        formatLinks: true,
                        useDivs: false,
                        placeholders: false,
                        mention: getMentionsConfig(),
                    }}
                    teams={teamsToUse}
                    hasTranscription={includeNotetaker}
                    {...rest}
                />
                {includeNotetaker && notetakerProps && (
                    <div className={styles.transcribe}>
                        <TranscribeButtonContainer {...notetakerProps} />
                    </div>
                )}
            </>
        )
    );
}
